export default {
  // General TR5
  'tr5.odometer': 'Odometer',
  'tr5.year': 'Year',
  'tr5.controls.sendToClosing': 'Send to Closing',
  'tr5.controls.sendToLost': 'Send to Not sold',

  // TRD
  'trd.description': 'Transport direct',
  'trd.tooltip':
    'Seller has opted to exclusively use Transport Direct, see Rate info',
  'trd.tooltip.promo':
    'Seller has opted to exclusively use Transport Direct, see Promo info',

  // General VDP
  'vdp.asis': 'As-is',
  'vdp.highbid': 'High bid!',
  'vdp.outbid': 'Outbid',
  'vdp.floorMet': 'Floor met',
  'vdp.floorPrice': 'Floor Price',
  'vdp.hasFloorPrice': 'Floor set',
  'vdp.closeToFloorPrice': 'Near floor!',
  'vdp.auctionEnded': 'Auction ended',
  'vdp.pendingEnded': 'Ended',
  'vdp.closingEnded': 'Closing Ended',
  'vdp.headerViews': '114 Views',
  'vdp.rateInfo': 'Rate info',
  'vdp.transportPromoOn': 'Promo on now!',
  'vdp.transportPromoInfoLong': 'Promotional rate info',
  'vdp.transportValueEstimated': 'estimated',
  'vdp.seller.detailsShownToBuyer': 'Details shown to buyer',

  // Pending Closing VDP
  'vdp.closing.buyer.disclaimer':
    'By placing a bid you verify that you have reviewed the vehicle details page and the vehicle history report.',
  'vdp.pending.buyer.button.reply': 'Reply',
  'vdp.pending.buyer.button.startNegotiation': 'Start negotiation',
  'vdp.pending.buyer.button.view': 'View negotiation',
  'vdp.pending.buyer.declined': 'Declined',
  'vdp.pending.buyer.label.buyerCounter': 'Your counter',
  'vdp.pending.buyer.label.buyerFirm': 'Firm at',
  'vdp.pending.buyer.label.buyerOffer': 'Your offer',
  'vdp.pending.buyer.label.finalAskingPrice': 'Final asking price',
  'vdp.pending.buyer.label.newAsking': 'New asking price',
  'vdp.pending.buyer.label.nowInActive': 'Now in Active Auction',
  'vdp.pending.buyer.label.nowInUpcoming': 'Now in Upcoming',
  'vdp.pending.buyer.label.sellerCounter': 'New counter',
  'vdp.pending.buyer.label.sellerOffer': 'New asking price',
  'vdp.pending.buyer.label.sentToSecondBidder': 'Sent to 2nd bidder',
  'vdp.pending.buyer.label.yourOffer': 'Your offer',
  'vdp.pending.buyer.label.yourTopBid': 'Your top bid',
  'vdp.pending.seller.button.reply': 'Reply',
  'vdp.pending.seller.button.sendToClosing': 'Send to Closing auction',
  'vdp.pending.seller.button.startNegotiation': 'Start negotiation',
  'vdp.pending.seller.button.viewNegotiation': 'View',
  'vdp.pending.seller.label.buyerCounter': 'New counter',
  'vdp.pending.seller.label.buyerFirm': 'Buyer firm at',
  'vdp.pending.seller.label.buyerOffer': 'New offer',
  'vdp.pending.seller.label.new': 'New',
  'vdp.pending.seller.label.finalAskingPrice': 'Your final asking price',
  'vdp.pending.seller.label.sellerCounter': "You're asking for",
  'vdp.pending.seller.label.sellerOffer': "You're asking for",

  // Confirmation Modals
  'vdp.confirmation.title.sameDealership':
    'Someone else at your dealership is currently the top bidder on this vehicle.',
  'vdp.confirmation.title.sameDealershipMessage':
    'Bidders from the same dealership will not go to Closing together. Do you still want to submit your bid?',
  'vdp.confirmation.title.sameDealerGroup':
    'Another user in your dealer group is top bidder.',
  'vdp.confirmation.msg.submitBid': 'Do you still want to submit your bid?',
  'vdp.confirmation.title.bidSeemsHigh':
    'Your bid of {bidAmount} seems like it might be high.',
  'vdp.confirmation.title.startingBidSeemsHigh':
    'Your starting bid of {bidAmount} seems like it might be high.',
  'vdp.confirmation.msg.confirmBidAmount':
    'Did you mean to enter a starting bid of {bidAmount}? If so you can continue below.',
  'vdp.confirmation.title.proxySeemsHigh':
    'Your proxy bid of {proxyAmount} seems like it might be high.',
  'vdp.confirmation.msg.confirmProxyAmount':
    'Did you mean to enter a proxy amount of {proxyAmount}? If so you can continue below.',
  'vdp.confirmation.yesBid': 'Yes, Bid',

  // Toaster Error Messages
  'vdp.error.startingBidLow':
    'The starting bid you entered was too low. Enter a starting bid of at least {minBidAmount}',
  'vdp.error.bidTooLow':
    'Your bid was too low. Enter a bid higher than the current one.',
  'vdp.error.startingBidLargerThanProxy':
    'Your starting bid is higher than your proxy amount. Enter a starting bid amount lower than your proxy amount.',
  'vdp.error.wrongBidIncrement':
    'Your bid was in the wrong increment. This vehicle requires bids in increments of {quickBidIncrement}',
  'vdp.error.noStartingBid': 'Please enter a starting bid amount.',
  'vdp.error.noBid': 'Please enter a bid amount.',
  'vdp.error.noProxy': 'Please enter a proxy amount.',
  'vdp.error.noProxyNoStartingBid':
    'You did not enter a proxy amount. Please enter both a starting bid and a proxy amount to set your proxy.',
  'vdp.error.proxyTooLow':
    'The proxy you entered was too low. Enter a proxy of at least {minProxyAmount}',
  'vdp.error.wrongProxyIncrement':
    'Your proxy bid was in the wrong increment. This vehicle requires bids in increments of {proxyIncrement}',
  'vdp.error.placingBid': 'There was a problem placing the bid.',
  'vdp.error.placingProxy': 'There was a problem placing a proxy on the trade.',
  'vdp.error.general':
    'There was a problem retrieving all the data on this trade, please wait or try refreshing the page',
  'bidding.error.unauthorized': 'Sorry, you are not authorized to bid.',
  'bidding.error.invalidAmount':
    'Your bid was in an invalid increment. Please enter bids below $1000 in increments of $50, or above $1000 in increments of $100.',
  'bidding.error.someoneElseBid':
    'Another person bid that amount just before you did. Please bid again.',

  // Toaster Success Messages
  'vdp.success.bidPlaced': 'Your bid has been successfully placed.',
  'vdp.success.proxySet':
    'Your proxy of {proxyAmount} has been set. You can edit it if you wish.',
  'vdp.success.vinCopied': 'VIN copied to clipboard',

  // VDP Header
  'vdp.launchTime.active.today': 'Launched today at {time}',
  'vdp.launchTime.yesterday': 'Launched yesterday at {time}',
  'vdp.launchTime.upcoming.today': 'Launching today at {time}',
  'vdp.launchTime.upcoming.today.sale': 'Today at {time}',
  'vdp.launchTime.tomorrow': 'Launching tomorrow at {time}',
  'vdp.launchTime.tomorrow.sale': 'Tomorrow at {time}',
  'vdp.launchTime.future': 'Launching {date} at {time}',
  'vdp.launchTime.future.sale': '{date} at {time}',
  'vdp.launchTime.past': 'Launched on {date} at {time}',
  'vdp.expirationTime.pending.today': 'Pending ends today at {time}',
  'vdp.expirationTime.pending.tomorrow': 'Pending ends tomorrow at {time}',
  'vdp.expirationTime.pending.future': 'Pending ends {date} at {time}',
  'vdp.watch': 'Watch',
  'vdp.watched': 'Watched',
  'vdp.close': 'Close',
  'vdp.share': 'Share vehicle',

  // VDP Overview
  'vdp.overview.vin': 'VIN',
  'vdp.overview.copyVin': 'Copy VIN:',
  'vdp.overview.transmissionDriveTrain': 'Powertrain',
  'vdp.overview.dateExpected': 'Date expected',
  'vdp.overview.specsFeatures': 'Full specs & features',
  'vdp.overview.make': 'Make',
  'vdp.overview.model': 'Model',
  'vdp.overview.trim': 'Trim',
  'vdp.overview.color': 'Exterior/Interior colour',
  'vdp.overview.seats': 'Seats',
  'vdp.overview.vehicleFeatures': 'Vehicle features',
  'vdp.overview.viewAll': 'View full list',
  'vdp.overview.media.overview': 'Overview',
  'vdp.overview.media.disclosure': ' Disclosure',
  'vdp.overview.media.videos': 'Videos',
  'vdp.overview.media.open': 'Open multimedia',
  'vdp.overview.tradeId': 'Trade ID',
  'vdp.overview.rateInfo.noQuote': 'No quote available',
  'vdp.overview.rateInfo.promoRateInfo': 'Promotional transport rate info',
  'vdp.overview.rateInfo.rateInfo': 'Transport rate info',

  // VDP Multimedia
  'vdp.multimedia.title': 'Multimedia',
  'vdp.multimedia.disclosureImages': 'Disclosure images',
  'vdp.multimedia.overviewImages': 'Overview images',
  'vdp.multimedia.video': 'Video',
  'vdp.multimedia.header.esc': 'Press the <esc>esc</esc> key to',
  'vdp.multimedia.interiordamage': 'Interior Damage',
  'vdp.multimedia.exteriordamage': 'Exterior Damage',

  // VDP Bid
  'vdp.bid.tradeState.active': 'Active',
  'vdp.bid.tradeState.upcoming': 'Upcoming',
  'vdp.bid.tradeState.pending': 'Pending',
  'vdp.bid.tradeState.closing': 'Closing',
  'vdp.bid.tradeState.won': 'Sold',
  'vdp.bid.tradeState.arrived': 'Landed',
  'vdp.bid.tradeState.delivered': 'Picked Up',
  'vdp.bid.tradeState.lost': 'Not Sold',
  'vdp.bid.proxyAmount': 'Proxy amount',
  'vdp.bid.startingBid': 'Starting Bid',
  'vdp.bid.auctionLaunched': 'Auction launched',
  'vdp.bid.bidAmount': 'Bid amount',
  'vdp.bid.currentBidAmount': 'Current bid amount',
  'vdp.bid.beFirst': 'Be the first to bid!',
  'vdp.bid.noBids': 'No bids yet',
  'vdp.bid.timeLeft.countdown.seconds': '{seconds}s',
  'vdp.bid.timeExtended': 'Extended',
  'vdp.bid.under30s': 'Under 30s',
  'vdp.bid.left': 'left',
  'vdp.bid.timeLeft': '{time}{unit} left',
  'vdp.bid.timeLeft.countdown': '{minutes}min {seconds}s',
  'vdp.bid.timeLeft.countdown.minutes': '{minutes}min',
  'vdp.bid.under1Min': 'Under 1 min',
  'vdp.bid.pendingVHR': 'The history report for this vehicle is still pending.',
  'vdp.bid.floorPrice': 'Floor: {floorPrice}',
  'vdp.bid.fullHistory': 'Full history',
  'vdp.bid.fullBidHistory': 'Full bid history',
  'vdp.bid.numberOfBids': '{numberOfBids, plural, one {# bid} other {# bids}}',
  'vdp.bid.yourBid': 'Your bid',
  'vdp.bid.placedDaysAgo':
    '{daysAgo, plural, one {# day ago} other {# days ago}}',
  'vdp.bid.placedHoursAgo':
    '{hoursAgo, plural, one {# hour ago} other {# hours ago}}',
  'vdp.bid.placedMinutesAgo':
    '{minsAgo, plural, one {# min ago} other {# mins ago}}',
  'vdp.bid.button.bid': 'Bid',
  'vdp.bid.button.placeBid': 'Place a bid',
  'vdp.bid.button.setProxy': 'Set proxy',
  'vdp.bid.currentBid': 'Current bid',
  'vdp.bid.button.setProxyAmount': 'Set {proxyAmount} proxy',
  'vdp.bid.button.editProxy': 'Edit proxy',
  'vdp.bid.button.setProxyAndBidAmount':
    'Bid {bidAmount} & set {proxyAmount} proxy',
  'vdp.bid.button.editProxyAmount': 'Edit {proxyAmount} proxy',
  'vdp.bid.button.quick.min.bid': 'Min bid',
  'vdp.bid.proxyMessage':
    'Proxy bidding: We’ll bid just enough to keep you top bidder, up to your proxy amount.',
  'vdp.bidModal.form.setProxy': 'Set a proxy Amount',
  'vdp.bidOverview.form.setProxy': 'Set proxy',
  'vdp.bid.editBidAmount': 'Edit',
  'vdp.bid.no.payment.method.message':
    'This dealership doesn’t have a payment method on file.',
  'vdp.bid.add.payment.method': 'Add a bank account in Settings now.',

  // VDP Inner Nav
  'vdp.innerNav.overview': 'Overview',
  'vdp.innerNav.condition': 'Condition',
  'vdp.innerNav.history': 'History',
  'vdp.innerNav.transportSeller': 'Transport & Seller',
  'vdp.innerNav.research': 'Price Analysis',

  // VDP Conditions Disclosures
  'vdp.conditions.title': 'Condition',
  'vdp.conditions.thirdPartyInspected': 'Third Party Inspected',
  'vdp.conditions.seeChecklist': 'See checklist',
  'vdp.conditions.nothingReported': 'Nothing reported',
  'vdp.conditions.inspectionDealerNotes': 'Inspection & dealer notes',
  'vdp.conditions.alwaysReadNotes':
    'Always read & review all notes before bidding.',
  'vdp.conditions.noNotes': 'No notes provided',

  // VDP History
  'vdp.history.title': 'History summary',
  'vdp.history.alwaysViewReport':
    'Always view the {reportType} report before bidding.',
  'vdp.history.waitingVHR': 'Waiting for vehicle history report.',
  'vdp.history.viewButton': 'View',
  'vdp.history.noneReported': 'None reported',

  // VDP Transport details
  'vdp.transport.Details': 'Transport details',
  'vdp.transport.Disclosures': 'Transport disclosures',
  'vdp.transport.NothingReported': 'Nothing reported',
  'vdp.transport.NotAvailable': 'Not available',
  'vdp.transport.NotDriveable': 'Not eligible for driveaway{delimeter}',
  'vdp.transport.NotDriveableDiscTitle':
    'This vehicle cannot be moved under its own power.',
  'vdp.transport.IsOversized': 'Is oversized',
  'vdp.transport.DateExp': 'Date expected',
  'vdp.transport.Estimate': 'Transport estimate',
  'vdp.transport.PromoOn': 'Promo on now!',
  'vdp.transport.PromoInfo': 'Promo info',
  'vdp.transport.VehicleLocation': 'Vehicle location',
  'vdp.transport.estimateNotAvailable':
    'Transport estimate not available for this vehicle right now',
  'vdp.transport.estimate': 'Transport from {city}, {province} to you: ',
  'vdp.transport.hasDateExpectedExceededLimit':
    'Date expected is more than {dateExpectedDaysLimit} days from launch',
  'vdp.transport.estimateWithStreet':
    'to {street}, {city}, {province}, {postalCode}',

  // VDP Seller Info
  'vdp.seller.heading': 'Seller info',
  'vdp.seller.qa': 'Questions & answers',
  'vdp.seller.qaButton': 'Open Q&A',
  'vdp.seller.dealer': 'Selling dealer',
  'vdp.seller.answers':
    '{chatCount, plural, one {# question & answer} other {# questions & answers}}',
  'vdp.seller.ratings':
    '({ratingsCount, plural, one {# rating} other {# ratings}})',
  'vdp.seller.network': 'Network:',
  'vdp.seller.payments': 'Accepted payments',
  'vdp.seller.noRatings': '(No ratings yet)',

  // VDP Research
  'vdp.research.heading': 'Price Analysis',
  'vdp.research.subheading':
    'Based on last 90 days of historical sales data for similar vehicles.',
  'vdp.research.average': 'Average Price',
  'vdp.research.highest': 'Highest Price',
  'vdp.research.lowest': 'Lowest  Price',
  'vdp.research.researchVin': 'Open this VIN in Market guide',
  'vdp.research.autoniq': 'Lookup this vehicle in Autoniq',
  'vdp.research.autoniq.short': 'Lookup in Autoniq',
  'vdp.research.no.marketguide.data.part1':
    'Not enough wholesale market data for ',
  'vdp.research.no.marketguide.data.part2': 'this year, make, model and trim ',
  'vdp.research.no.marketguide.data.part3':
    'of this vehicle. Find similar vehicles by viewing in Market Guide and expanding the year range, or picking more trims.',

  // VDP Share Retail
  'vdp.retail.price.placeholder': 'Enter customer price',
  'vdp.retail.description.placeholder': 'Enter description',
  'vdp.retail.share': 'Share this vehicle with a customer',
  'vdp.retail.shareUrl': 'Share this vehicle URL',
  'vdp.retail.message':
    'Create a customer-friendly view of this page that you’re in control of to send to a potential customer.',
  'vdp.retail.link': 'Create Customer Link',
  'vdp.retail.noCarfax.title': 'CARFAX not ready yet',
  'vdp.retail.noCarfax.message':
    'You cannot create a customer link until the CARFAX has been added to this listing. Try again in a few minutes.',
  'vdp.retail.vhr': 'Vehicle history report',
  'vdp.retail.vhr.carfax':
    "See below for a link to this vehicle's CARFAX Canada report.",
  'vdp.retail.kilometres': 'Kilometres',
  'vdp.retail.transmission': 'Transmission',
  'vdp.retail.engine': 'Engine',
  'vdp.retail.drivetrain': 'Drive train',
  'vdp.retail.fuelType': 'Fuel type',
  'vdp.retail.seats': 'Seats',
  'vdp.retail.exteriorInterior': 'Exterior / Interior colour',

  // VDP Footer
  'vdp.footer.findMore': 'Find more vehicles in {tradeState} auction.',
  'vdp.footer.backTo': 'BACK TO {tradeState}',

  // Mini VDP
  'mini.vdp.nothing.selected.heading': 'No vehicle selected.',
  'mini.vdp.nothing.selected.subheading':
    'Select a vehicle to the left to see details and bid.',

  // Modals
  'modal.yes': 'Yes',
  'modal.ok': 'Ok',
  'modal.noThanks': 'No thanks',
  'modal.cancel': 'Cancel',
  'modal.confirmation.loading': 'Loading...',
  'modal.confirmation.confirmYourBid.title':
    'Have you read the details page & history report for this vehicle?',
  'modal.confirmation.confirmYourBid.description':
    'We’ll only ask once for this vehicle – further bids will not prompt this message.',
  'modal.submit': 'Submit',
  'auto.win.on.disclaimer':
    'Auto-win is on: We’ll use your proxy amount to try and win if the floor price isn’t met or during a negotiation.',

  // Tooltips
  'tooltips.isFloorPriceMet':
    'Floor price has been met, this vehicle is guaranteed to sell.',
  'tooltips.hasFloorPrice':
    'If the seller’s floor price is met, this vehicle will be guaranteed to sell.',
  'tooltips.isCloseToFloorPrice':
    'Current bid is almost at the seller’s floor price - keep bidding!',

  // List Header, Footer & Empty state
  'list.footer.sell.looking.pending':
    'Looking for more vehicles? It could be in Closing or Landed.',
  'list.header.buy.pending.negotiations.subheading':
    'Unsuccessful negotiations will move the auction to Not sold.',
  'list.modal.pending.moveToClosing.confirm.message':
    'You cannot send this vehicle to the Closing Auction since there is only 1 bidder. <b>Accept the final bid of $ {acv} and move this vehicle to Sold?</b>',
  'list.modal.pending.moveToLost.confirm.confirm': 'Move To Not sold',
  'list.modal.pending.moveToLost.confirm.error':
    'Something went wrong marking the trade as Not sold',
  'list.modal.pending.moveToLost.confirm.success':
    'Vehicle has been sent to Not sold.',
  'list.modal.pending.moveToLost.confirm.title':
    'End auction and move to Not sold',
  'list.modal.pending.openNetwork.park.confirm.message':
    'When you Park this trade the dealer group network version of this trade will be moved to Not sold.',
  'list.openTrade.dgn.negotiateFirst.error.message':
    'You must negotiate on the dealer group network trade first. If you do not want to negotiate, mark it Not sold. When the dealer group network version of this trade is marked Not sold you will be able to negotiate on this trade.',

  // Toaster
  'toaster.dismiss.message': 'Dismiss',

  // Card
  'list.card.negotiation.topBid': 'Top bid',
  'list.card.negotiation.sendClosing': 'Send to Closing auction',

  // Negotiation modals
  'modal.decision.sendToClosing.message.dgnTrade':
    'The top two bidders will continue to bid until there is a winner. The Open network version of this trade will be sent to Not sold.',
  'modal.decision.sendToClosing.message.openTrade':
    'The top two bidders will continue to bid until there is a winner. The dealer group network version of this trade will be sent to Not sold.',
  'modal.negotiation.accept.description':
    'This will successfully end the negotiations and move this vehicle to Sold or Landed if in-stock.',
  'modal.negotiation.decline.seller.description.msg2':
    'If you do not want to continue the auction, send the vehicle to Not sold.',
  'modal.negotiation.decline.seller.sendToLost': 'Send to Not sold',
  'modal.negotiation.stayFirm': 'Stay firm',
  'modal.negotiation.tutorial.seller.dgn.firstReply.message1':
    'If the negotiation is successful the vehicle will move to Sold or Landed.',
  'modal.negotiation.tutorial.seller.dgn.message1':
    'If the negotiation is successful the vehicle will move to Sold or Landed if in stock.',
  'modal.negotiation.tutorial.seller.dgn.message2':
    'If you or the buyer declines in the negotiation this dealer group network trade will be sent to Not sold.',
  'modal.negotiation.tutorial.seller.message0':
    'If the negotiation is successful the vehicle will move to Sold or Landed if in stock.',
  'modal.negotiation.tutorial.seller.open.start.message0':
    'If the negotiation is successful the vehicle will move to Sold or Landed if in stock.',
  'modal.negotiation.tutorial.seller.open.start.message1':
    'If you or the buyer declines in the negotiation this open network trade will be sent to Not sold.',
  'negotiation.send.to.lost': 'Send to Not sold',

  // TradeStates
  'tradeState.won': 'Sold',
  'tradeState.arrived': 'Landed',
  'tradeState.delivered': 'Picked Up',
  'tradeState.lost': 'Not Sold',

  // Retail Tools Setting
  'retail.tools.setting': 'Retail tools',
  'list.nav.searchbar.modal.closeButton': 'CLOSE',
  'retail.tools.setting.description':
    'Personalize content your customers will see.',
  'retail.tools.setting.heading': 'Dealership info',
  'retail.tools.setting.heading.description':
    'Updating these settings will also change the appearance for all previously generated links from this dealership.',
  'retail.tools.setting.upload.logo': 'Upload Logo',
  'retail.tools.setting.upload.logo.for': 'Upload logo for',
  'retail.tools.setting.edit.logo': 'Edit Logo',
  'retail.tools.setting.edit.logo.for': 'Edit logo for',
  'retail.tools.setting.upload.logo.description':
    'The dealership logo will appear to your customers on the inspection landing page.',
  'retail.tools.setting.upload.logo.error': 'Something went wrong.',
  'retail.tools.setting.logo.note':
    '<b>NOTE:</b> Images will accept .PNG and .JPEG. Transparent background preferred.',
  'retail.tools.setting.logo.size':
    'Images must be a minimum of 500 x 500 pixels and less than 15MB',
  'retail.tools.setting.retailVdp.heading': 'Retail condition report info',
  'retail.tools.setting.retailVdp.heading.for':
    'Retail condition report info for',
  'retail.tools.setting.tiah.heading': 'Retail inspection landing page',
  'retail.tools.setting.tiah.heading.for': 'Retail inspection landing page for',
  'retail.tools.setting.tiah.description':
    'This is the page that customers first see when they open the customer invite link sent by your dealership. This is found under Selling / Create.',
  'retail.tools.setting.retailVdp.description':
    'This information will be pre-populated when you share a vehicle from the condition report. You can also change it if you wish at that time.',
  'retail.tools.setting.retailVdp.inventory.disclaimer':
    'If the customer is not interested in the vehicle you’re sharing, we will show a link to your other used inventory',
  'retail.tools.setting.warning': 'WARNING',
  'retail.tools.setting.logo.upload.error':
    "The image you tried to upload doesn't meet the requirements.Try again.",
  'retail.tools.setting.warning.message':
    'Updating these settings will also change the appearance for all previously generated links from this dealership.',
  'list.filters.save': 'Save',
  'list.filters.add.logo': 'Add logo',
  'list.filters.edit.details': 'Edit details',
  'retail.tools.setting.confirmation':
    'Your configurations have been saved. The updates are now live on your retail tools!'
};
